/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 *
 * Jellyfin API
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/.
 */
/**
 * An enum representing types of video ranges.
 * @export
 * @enum {string}
 */
const VideoRangeType = {
    Unknown: 'Unknown',
    Sdr: 'SDR',
    Hdr10: 'HDR10',
    Hlg: 'HLG',
    Dovi: 'DOVI',
    DoviWithHdr10: 'DOVIWithHDR10',
    DoviWithHlg: 'DOVIWithHLG',
    DoviWithSdr: 'DOVIWithSDR',
    Hdr10Plus: 'HDR10Plus'
};

export { VideoRangeType };
